module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/eed5f7bdcb65d06bf30ce5214b3c937e.png";